export default "__VITE_PUBLIC_ASSET__274bc1a1__"